module.exports = __webpack_public_path__ + "static/media/Medcare.7841497b.PNG";